import React from 'react';

import styles from '../../../../pages/ClubProfiles/club.scss';
import { getClickAttrs } from '../../../Analytics/gtag';

const CreateEventButton = (props) => {
    return (
        <button
            type="button"
            className={`btn btn-primary ${props.small ? 'btn-sm' : ''} text-uppercase ${styles.primaryActionButton}`}
            onClick={props.onClick}
            {...getClickAttrs({
                category: 'Create Event',
                context: 'Create Event Button',
                location: props.clickLocation,
            })}
        >
            {props.isTournamentClub ? `GET IN TOUCH` : `Create Event`}
        </button>
    );
};

export default CreateEventButton;
